import { Component, OnInit } from '@angular/core';
import { FileUploader } from 'ng2-file-upload';
import { Album } from '../../../model/album';

@Component({
  selector: 'app-galeria-form',
  templateUrl: './galeria-form.component.html',
  styleUrls: ['./galeria-form.component.css']
})
export class GaleriaFormComponent implements OnInit {

  private uploader: FileUploader = new FileUploader({});
  private usuario_logado: any = JSON.parse(sessionStorage.getItem("usuario"));
  album: any;
  usuario: any; 

  constructor() { 
    this.album = new Album();
    this.usuario = JSON.parse(sessionStorage.getItem("usuario"));
   }

  ngOnInit() { }

  upload_file() {
    document.getElementById('imagem-input').click();
  }

  limpar(){
    this.uploader.clearQueue();
  }  

  limparTudo(){
    this.uploader.clearQueue();
    this.album = new Album();
  }

  cadastrarAlbum() {
    this.album.status = true;
    this.album.log_usuario = this.usuario['id'];
    this.album.log_data = new Date();
    this.album.data = new Date();

  }

}


// WEBPACK FOOTER //
// ./src/app/gerenciador/dashboard/galeria-form/galeria-form.component.ts